import { useCallback } from "react";

import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import { z } from "zod";

import { SignInPageConnector } from "@pages/sign-in/sign-in-page-connector";

import { Route as WalletRoute } from "../_private/wallet";
import { Route as SignUpRoute } from "../_public/sign-up";
import { Route as ResetPasswordRoute } from "./password-reset.tsx";

export const Route = createFileRoute("/_public/sign-in")({
  beforeLoad: ({ context, search }) => {
    const isAuthenticated = context.getAuthStatus();
    if (isAuthenticated) {
      throw redirect({ to: search.redirect || WalletRoute.fullPath });
    }
  },
  component: RouteComponent,
  validateSearch: z.object({
    redirect: z.string().optional().catch(undefined),
  }),
});

function RouteComponent() {
  const { redirect } = Route.useSearch();
  const navigate = useNavigate();
  const handleSuccessSignIn = useCallback(async () => {
    await navigate({ to: redirect || WalletRoute.fullPath });
  }, [navigate, redirect]);
  const handleCreateAccount = useCallback(async () => {
    await navigate({ to: SignUpRoute.fullPath });
  }, [navigate]);
  const handleResetPassword = useCallback(
    async (email?: string) => {
      await navigate({ search: { email }, to: ResetPasswordRoute.fullPath });
    },
    [navigate],
  );

  return (
    <SignInPageConnector
      onCreateAccount={handleCreateAccount}
      onResetPassword={handleResetPassword}
      onSuccessSignIn={handleSuccessSignIn}
    />
  );
}
